export const SET_ALERTS_TAB = "SET_ALERTS_TAB";
export const TOGGLE_CLOSE = "TOGGLE_CLOSE";
export const TOGGLE_OPEN = "TOGGLE_OPEN";
export const TOGGLE_WAV_CAM = "TOGGLE_WAV_CAM";
export const CAMERA_TO_DOCK_MODE = "CAMERA_TO_DOCK_MODE";
export const CLOSE_NOTIFICATION_FAILED = "CLOSE_NOTIFICATION_FAILED";
export const CLOSE_NOTIFICATIONS_FAILED = "CLOSE_NOTIFICATIONS_FAILED";
export const REOPEN_ALERT_FAILED = "REOPEN_ALERT_FAILED";
export const REOPEN_ALERTS_FAILED = "REOPEN_ALERTS_FAILED";
export const GET_ARCHIVE_FAILED = "GET_ARCHIVE_FAILED";
export const GET_ARCHIVE_SUCCESS = "GET_ARCHIVE_SUCCESS";
export const CLOSE_NOTIFICATION_COMPLETE = "CLOSE_NOTIFICATION_COMPLETE";
export const CLOSE_NOTIFICATIONS_COMPLETE = "CLOSE_NOTIFICATIONS_COMPLETE";
export const SHOW_ALERT = "SHOW_ALERT";
export const HIDE_ALERT = "HIDE_ALERT";
export const DOCK_APP_STATE_RECEIVED = "DOCK_APP_STATE_RECEIVED";
export const TOGGLE_WAV_CAM_LABELS = "TOGGLE_WAV_CAM_LABELS";
export const WATCHLISTS_RECEIVED = "WATCHLISTS_RECEIVED";
export const WATCHLIST_ENTRIES_RECEIVED = "WATCHLIST_ENTRIES_RECEIVED";
export const CLEAR_WATCHLIST_ENTRIES = "CLEAR_WATCHLIST_ENTRIES";

// IMPORTANT: I have no idea why, but the camera dock breaks unless these actions are left here.
// It doesn't seem like any actions are using these, but as soon as I remove any of them, the dock breaks.
//////////// CAMERA DOCK /////////////////

export const CAMERA_DOCKED = "CAMERA_DOCKED";
export const REMOVE_DOCKED_CAMERA = "REMOVE_DOCKED_CAMERA";
export const CAMERAS_RECEIVED = "CAMERAS_RECEIVED";
export const CAMERA_PRIORITY_SET = "CAMERA_PRIORITY_SET";
export const TOGGLE_FIND_NEAREST = "TOGGLE_FIND_NEAREST";
export const CLEAR_FIND_NEAREST = "CLEAR_FIND_NEAREST";
export const CLEAR_CAMERA_REPLACE_MODE = "CLEAR_CAMERA_REPLACE_MODE";

export const DOCKED_CAMERA_VIDEO_STREAM_RECEIVED = "DOCKED_CAMERA_VIDEO_STREAM_RECEIVED";
export const DOCKED_CAMERA_SUBSCRIPTION_RECEIVED = "DOCKED_CAMERA_SUBSCRIPTION_RECEIVED";
export const CLEAR_CAMERA_STREAM = "CLEAR_CAMERA_STREAM";
